import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class InputsNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        this.openLinkPanel = (options) => {
            return this.ps.hostAPI.editor.openLinkPanel(options);
        };
        this.openMediaPanel = (options) => {
            return this.ps.hostAPI.editor.openMediaPanel(options);
        };
        this.openColorPicker = (options, onColorChange) => {
            return this.ps.hostAPI.editor.openColorPicker(options, onColorChange);
        };
        this.openFontPicker = (options, onFontChange) => {
            return this.ps.hostAPI.editor.openFontPicker(options, onFontChange);
        };
        this.openFontPickerV2 = (options, onFontChanged) => {
            return this.ps.hostAPI.editor.openFontPicker(options, () => { }, onFontChanged);
        };
    }
}
InputsNamespace.namespace = 'inputs';
//# sourceMappingURL=InputsNamespace.js.map